/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryList(_, data) {
      return await api.post(`/api/trade/getListByType`, data);
    },
    async queryPublishList(_, data) {
      return await api.post(`/api/trade/myPublish`, data);
    },
    async queryFilter(_, data) {
      return await api.post(`/api/trade/filterList`, data);
    },
    async queryRecommend(_, data) {
      return await api.post(`/api/trade/recommend`, data);
    },
    async queryDetail(_, data) {
      return await api.post(`/api/trade/detail`, data);
    },
    async add(_, data) {
      return await api.post(`/api/trade/add`, data);
    },
  },
}
